import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgInstacartCarrot({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Instacart_Carrot_svg__Layer_1"
      x={0}
      y={0}
      viewBox="0 0 42.3 52.9"
      xmlSpace="preserve"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <style>{".Instacart_Carrot_svg__st0{fill:#0aad0a}"}</style>
      <path
        className="Instacart_Carrot_svg__st0"
        d="M36.4 8.6c-2.3 0-4 1-5.5 3.2l-4.4 6.4V0H15.9v18.2l-4.4-6.4C9.9 9.6 8.2 8.6 5.9 8.6 2.4 8.6 0 11.2 0 14.4c0 2.7 1.3 4.5 4 6.3l17.1 11 17.1-11c2.7-1.8 4-3.5 4-6.3.1-3.2-2.3-5.8-5.8-5.8z"
      />
      <path
        d="M21.1 34.4c10.2 0 18.5 7.6 18.5 18.5h-37C2.6 42 11 34.4 21.1 34.4z"
        fill="#ff7009"
      />
      <g>
        <path
          className="Instacart_Carrot_svg__st0"
          d="M36.4 8.6c-2.3 0-4 1-5.5 3.2l-4.4 6.4V0H15.9v18.2l-4.4-6.4C9.9 9.6 8.2 8.6 5.9 8.6 2.4 8.6 0 11.2 0 14.4c0 2.7 1.3 4.5 4 6.3l17.1 11 17.1-11c2.7-1.8 4-3.5 4-6.3.1-3.2-2.3-5.8-5.8-5.8z"
        />
        <path
          d="M21.1 34.4c10.2 0 18.5 7.6 18.5 18.5h-37C2.6 42 11 34.4 21.1 34.4z"
          fill="none"
        />
      </g>
    </svg>
  );
}
export default SvgInstacartCarrot;
